import {ProductInfo, StorageSeason} from "src/model/ProductMatch";

export const ADD_PRODUCT = 'ADD_PRODUCT';
export const DEL_PRODUCT = 'DEL_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const DEL_ALL_PRODUCTS = 'DEL_ALL_PRODUCTS';
export const UPDATE_ALL_PRODUCTS = 'UPDATE_ALL_PRODUCTS'
export const UPDATE_STORAGE_SEASON = 'UPDATE_STORAGE_SEASON';
export const UPDATE_PROGRAMS = 'UPDATE_PROGRAMS';

export interface BulkProductAction {
    readonly type: string,
    readonly product?: any;
    readonly oldProduct?: any;
    readonly storageSeason?: any;
    readonly programs?: any;
    readonly products?: any;
}

export const addProduct = (product: ProductInfo): BulkProductAction => ({
    type: ADD_PRODUCT,
    product: product
});

export const delProduct = (product: ProductInfo): BulkProductAction => ({
    type: DEL_PRODUCT,
    product: product
});

export const updateProduct = (product: ProductInfo, oldProduct: ProductInfo): BulkProductAction => ({
    type: UPDATE_PRODUCT,
    product: product,
    oldProduct: oldProduct
});

export const updateAllProducts = (products: Array<ProductInfo>): BulkProductAction => ({
    type: UPDATE_ALL_PRODUCTS,
    products: products,
});

export const delAllProducts = (): BulkProductAction => ({
    type: DEL_ALL_PRODUCTS,
});

export const updateStorageSeason = (season: StorageSeason): BulkProductAction => ({
    type: UPDATE_STORAGE_SEASON,
    storageSeason: season
})

export const updatePrograms = (programs: Array<string>): BulkProductAction => ({
    type: UPDATE_PROGRAMS,
    programs: programs
})
